"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 3.661a.7.7 0 0 0-.38.112l-6.298 4.06a.7.7 0 0 0 0 1.177l6.299 4.06a.7.7 0 0 0 .379.111v-1.533L4.993 8.421 10 5.194zm1.063 7.303 3.944-2.543-3.944-2.542V4.213l5.615 3.62a.7.7 0 0 1 0 1.177l-5.616 3.62zM10 14.806l-5.92-3.815a.7.7 0 1 0-.758 1.176l6.299 4.06a.7.7 0 0 0 .379.112zm1.063.98v-1.665l4.857-3.13a.7.7 0 1 1 .758 1.176z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.938 3.531a.531.531 0 0 1 1.062 0V16.47a.531.531 0 1 1-1.062 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m9.241 4.944-5.312 3.5 5.312 3.5z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=VersionCompareIcon20.js.map